<template id="AdminUser">

	<div class="pantalla">
		<div class="row">
			<h3>Administrador de Accesos al Portal</h3>

			<h5 style="margin-top: 24px">Agregar usuarios</h5>
            <hr class="red" style="margin-bottom: 0">

			<form id="formCarga" class="form-horizontal col-md-12" role="form">

				<!-- modal para la carga -->
                <loading :active.sync="isLoading"
                         color="#9D2449" background-color="#CCCCCC" />

				<div class="form-group" style="margin-left: 100px">

					<label style="margin: 20px 0px;">Seleccionar archivo:</label>
					
					<div class="inputfile-box">
						<input type="file" id="file" ref="file" class="inputfile" v-on:change="validaSeleccion(this)"/>
						<label for="file" class="file-label">
							<span id="file-name" class="file-box"></span>
							<span class="file-button">
								Examinar
							</span>
						</label>
					</div>

					<p style="margin-top: 20px; font-size: 11px; font-weight: bold;">
						Recuerda que: 
						<u style="text-decoration: none; font-weight: normal;">
							<li>El archivo debe ser en formato csv</li>
							<li>El tamaño del archivo no debe de exceder de los 500 KB </li>
							<li>El nombre del archivo no debe ser mayor a 100 caracteres </li>
						</u>
					</p>

					<div class="text-center" style="margin-top: 40px">
						
						<button type="button" class="btn btn-danger" style="margin: 5px" v-on:click="limpiaImagen()">Limpiar</button>
						<!-- <button type="button" class="btn btn-primary" style="margin: 5px" v-on:click="guardaImagen()">Enviar</button> -->
                        <button type="button" class="btn btn-primary" style="margin: 5px" data-toggle="modal" data-target="#modalValida">Enviar</button>

					</div>

					
				</div>

			</form>

		</div>



		<!-- MODAL DE VALIDACIÓN DE LA ACTUALIZACIÓN -->
		<div class="modal fade" id="modalValida" tabindex="-1" role="dialog" aria-labelledby="modalAvisoLabel">
			<div class="modal-dialog modal-lg" style="width: 540px">
				<div class="modal-content">
					<div class="modal-header">
						<h4 class="modal-title">Se actualizarán las credenciales de acceso de los usuarios al Portal.</h4>
                        <h4 class="modal-title" style="color: green; ">Esta acción no se puede deshacer.</h4>
					</div>
				</div>
				<div class="modal-body text-center" style="background-color: white">
					<h3>¿Desea continuar?</h3>
				</div>
				<div class="modal-footer" style="background-color: white">
					<button type="button" class="btn btn-danger" data-dismiss="modal" >Cancelar</button>
					<button type="button" class="btn btn-primary" data-dismiss="modal" @click="guardaImagen()" >Aceptar</button>
				</div>
			</div>
		</div>

	</div>

</template>

<style scoped>

	a {
		color: #9D2449;
	}

	a:hover {
		color: #b38e5d;
	}

	input[type=checkbox] {
		/* Double-sized Checkboxes */
		-ms-transform: scale(1.5); /* IE */
		-moz-transform: scale(1.5); /* FF */
		-webkit-transform: scale(1.5); /* Safari and Chrome */
		-o-transform: scale(1.5); /* Opera */
		transform: scale(1.5);
		padding: 10px;
	}

	.checkboxtext {
		/* Checkbox text */
		display: inline;
	}

</style>

<script>

	import axios from 'axios';
	import Vue from 'vue';

	export default {
		name: "AdminUser",
		data() {
			return {
				isLoading: false,
				file: '',
				imagenes: [],
				ultimaImagen: false
			}
		},
		mounted() {
            this.isLoading = false;
		},
		methods: {
			validaSeleccion() {

				const validaFile = this.$refs.file.files[0];

				if (validaFile.size > 500000) {

					this.llamarAlertaWarining('Excede el tamaño permitido, sólo se permiten archivos de hasta 500kb.');
					this.$refs.file.value = null;
					this.file = '';
					document.getElementById("file-name").innerHTML = '';
					return;
				}
                console.log("Tipo: " + validaFile.type);
				if (validaFile.type != "text/csv" && validaFile.type != "application/vnd.ms-excel") {

					this.llamarAlertaWarining('Archivo inválido, sólo se permiten archivos con extensión .csv');
					this.$refs.file.value = null;
					this.file = '';
					document.getElementById("file-name").innerHTML = '';
					return;
				}

				if ((validaFile.type == "text/csv" && validaFile.name.length > 104)
                 ) {
					
					this.llamarAlertaWarining('El nombre del archivo no debe ser mayor a 100 caracteres.');
					this.$refs.file.value = null;
					this.file = '';
					document.getElementById("file-name").innerHTML = '';
					return;
				}

				this.file = this.$refs.file.files[0];
				document.getElementById("file-name").innerHTML = validaFile.name;
			},
			guardaImagen() {

				this.isLoading = true;

				//Validamos que se haya seleccionado la imagen
				if(this.file == null || this.file == '' || this.file == undefined) {
					
					this.isLoading = false;
					this.llamarAlertaWarining('No ha seleccionado ningún archivo.');

					return;
				}

				//Iniciamos con el proceso de cargar anchivo
				let formData = new FormData();
				formData.append('file', this.file);
				//formData.append('param', new Blob([JSON.stringify({idEmpleadoLogueado: localStorage.getItem('user_id')})],{type:"application/json"}));

				axios.post(Vue.prototype.$globalHost + '/guardaUsuarios',
					formData,
					{
					headers: {
						'Content-Type': 'multipart/form-data',
						'authorization': localStorage.getItem('token')
					}
				}).then(response => {

					console.log(response.data);
					this.$refs.file.value = null;
					this.file = '';
					document.getElementById("file-name").innerHTML = '';
                    this.isLoading = false;
                    this.llamarAlertaWarining('Se registraron ' + response.data + ' usuarios.');
				})
				.catch(error => {
					this.isLoading = false;
                    if (error.response.status === 500) {
                        this.llamarAlertaError(error );
                    } else {
                        this.procesarErrorYdesplegarMensaje(error,
                    'Ocurrió un error al procesar el archivo')
                    }
                })
			},
			limpiaImagen() {

				this.$refs.file.value = null;
				this.file = '';
				document.getElementById("file-name").innerHTML = '';
			}
		}
	}

</script>